'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function GGFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-qwibol55j", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-kiwlwmxod", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-1pksgsccy" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-1pksgsccy", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-qwibol55j)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f7fcff", xlinkHref: "#mantine-1pksgsccy" }), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-kiwlwmxod)" }, /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M12 0h8v8h12v8H20v8h-8v-8H0V8h12z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#feca00",
        d: "M18.966 3.046l-.957 1.76L18 4.804V10h7.106v-.057l1.76-.998v5.96L25.201 14H18v5.046h.009l.957 1.76h-5.96L14 19.048V14H6.769l-1.663.906v-5.96l1.76.997-.001.057H14V4.801l-.994-1.755z"
      }
    ))))
  );
}

export { GGFlag };
//# sourceMappingURL=GG.mjs.map
